import * as Lucide from 'lucide-react';

// Curated icon set offered in the admin picker
export const ICON_OPTIONS = [
  'CalendarDays', 'Car', 'ScanLine', 'Wrench', 'AppWindow', 'LayoutGrid',
  'Gauge', 'Activity', 'Wifi', 'Zap', 'Cpu', 'Database', 'ShieldCheck',
  'Map', 'MapPin', 'Truck', 'ClipboardList', 'FileText', 'BarChart3',
  'LineChart', 'Bell', 'Settings', 'Users', 'Package', 'Boxes', 'Camera',
  'QrCode', 'Radio', 'BatteryCharging', 'Plug', 'Hammer', 'Ruler', 'Cog',
  'Terminal', 'Globe', 'Rocket', 'Briefcase', 'Clock', 'CheckCircle2', 'Search',
];

export function getIcon(name) {
  return Lucide[name] || Lucide.AppWindow;
}

// Accent color options (no purple/pink saturated combos)
export const COLOR_OPTIONS = [
  { key: 'teal', from: '#2EE6C5', to: '#14b8a6' },
  { key: 'cyan', from: '#2BB6FF', to: '#22d3ee' },
  { key: 'blue', from: '#3b82f6', to: '#2BB6FF' },
  { key: 'sky', from: '#38bdf8', to: '#0ea5e9' },
  { key: 'emerald', from: '#34d399', to: '#10b981' },
  { key: 'lime', from: '#a3e635', to: '#65a30d' },
  { key: 'amber', from: '#fbbf24', to: '#f59e0b' },
  { key: 'orange', from: '#fb923c', to: '#f97316' },
  { key: 'rose', from: '#fb7185', to: '#f43f5e' },
  { key: 'slate', from: '#94a3b8', to: '#64748b' },
];

export function getColor(key) {
  return COLOR_OPTIONS.find((c) => c.key === key) || COLOR_OPTIONS[0];
}

export function slugify(text) {
  return (text || '')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
